module.exports = __webpack_public_path__ + "static/mobilePhone-de1bbad563bc6ac9ec01b1b89487a85d.png";